import { PinataSDK } from "pinata";
import { KEYSERVER_URL } from "./Client";
import { StoredMetadata } from "./Metadata";

export interface Storage {
  upload: (data: StoredMetadata) => Promise<string>;
}

export class KeyserverStorage implements Storage {
  public async upload(data: StoredMetadata): Promise<string> {
    const res = await fetch(`${KEYSERVER_URL}/storage/fs`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return (await res.json()).url;
  }
}

// Basically the same as Keyserver storage in terms of how we use it. At some
// point we'll likely merge them and have only one of them available, we shall
// see.
export class S3Storage implements Storage {
  public async upload(data: StoredMetadata): Promise<string> {
    const res = await fetch(`${KEYSERVER_URL}/storage/s3`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return (await res.json()).url;
  }
}

export interface IpfsSettings {
  pinata: boolean;
  pinata_jwt?: string;
  pinata_gateway?: string;
}

export class IpfsStorage implements Storage {
  settings: IpfsSettings;

  constructor(settings: IpfsSettings) {
    this.settings = settings;
  }

  public async upload(data: StoredMetadata): Promise<string> {
    // Make sure at least one pinning service is enabled
    if (!this.settings.pinata) {
      throw "No pinning service enabled";
    }

    let cid;
    if (this.settings.pinata) {
      const pinata = new PinataSDK({
        pinataJwt: this.settings.pinata_jwt,
        pinataGateway: this.settings.pinata_gateway,
      });
      const upload = await pinata.upload.public.json(data);
      cid = upload.cid;
    }

    return "ipfs://" + cid!;
  }
}
